Ext.define('SA.view.EnableHistoricalViews', {
    alias: 'widget.enable-historical-views',
    extend: 'SA.view.SimpleContainer',

    cls: 'sa-enable-historical-views',

    initComponent() {
        this.items = [
            {
                xtype: 'component',
                cls: 'sa-enable-historical-views-header',
                html: 'Enable Historical Views'
            }, {
                xtype: 'simple-container',
                cls: 'sa-enable-historical-views-content',

                items: [
                    {
                        xtype: 'simple-container',
                        cls: 'sa-enable-historical-views-toggle-wrap',

                        items: [
                            {
                                xtype: 'component',
                                cls: 'sa-enable-historical-views-toggle-label',
                                html: 'Historical Views:'
                            }, {
                                xtype: 'sa-toggle-switch',
                                checked: this.enabled,
                                cls: 'sa-enable-historical-views-toggle',
                                itemId: 'toggle',
                                leftText: 'Off',
                                rightText: 'On'
                            }
                        ]
                    }, {
                        xtype: 'component',
                        cls: 'sa-enable-historical-views-text',

                        html: [
                            '<p>',
                                'Since geographic boundaries change over time, data from earlier census ',
                                'releases might not be available in current boundaries. Selecting a historical ',
                                'census geographic year allows you to access data and locations that are in ',
                                'older census geographic units by filtering the data and locations available in ',
                                'the tabs on the left side of the screen.',
                            '</p>',
                            '<p>',
                                `For example, if you select the ${this.exampleCensusReleaseYear} census geographic `,
                                `year you will only see locations from ${this.exampleCensusReleaseYear} and data `,
                                `that is compatible with the ${this.exampleCensusReleaseYear} geographic year, all `,
                                'other data and locations will be hidden. You can then search for and add these ',
                                'data variables and locations to your project.',
                            '</p>',
                            '<p>',
                                'This is an advanced feature, so please contact support at ',
                                '<a href="mailto:support@simplyanalytics.com">support@simplyanalytics.com</a> ',
                                'if you have any questions about using this feature.',
                            '</p>'
                        ]
                    }
                ]
            }
        ];

        this.callParent();
    },

    initEvents() {
        this.callParent();

        this.down('sa-toggle-switch').on('change', this.onChangeToggle, this);
    },

    onChangeToggle(toggle, enabled) {
        this.fireEvent('toggle', enabled);
    }
});